module.exports = __webpack_public_path__ + "assets/img/con6-bg.00bceaf6.jpg";